import getCurrentStep from './get-current-step'

const getCurrentSection = (ctx) => {
  const { journey } = ctx
  const step = getCurrentStep(ctx)
  return journey?.sections?.find((section) => section.id === step?.sectionId) || null
}

export default getCurrentSection
